import styles from './Fields.module.css'

export function fieldControlClassName(kind, size = 'default', className = '') {
  return [styles.control, styles[kind], size === 'compact' ? styles.compact : '', className].filter(Boolean).join(' ')
}
